import { NotificationManager } from 'react-notifications';
import { Link, Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import accounting from 'accounting';
import _ from 'lodash';
import { limpiarCarrito, quitarCarrito, singleBuy, getTransactionDetails } from '../actions';

class Carrito extends Component {

  constructor(props){
    super(props);

    this.clearList = this.clearList.bind(this);
    this.removeProduct = this.removeProduct.bind(this);
    this.processPurchase = this.processPurchase.bind(this);
  }

  componentDidMount(){
    this.props.getTransactionDetails(4);
  }

  renderLista(){
    let productos = _.map(this.props.carrito, (pro, key)=>{
      return (
        <tr key={pro.id}>
          <th scope="row">{pro.id}</th>
          <td>{pro.titulo}</td>
          <td className="cost">{accounting.formatMoney(pro.costo, "Gs", 0, ".")}.-</td>
          <td>
            <button
              className="btn btn-secondary"
              onClick={()=>this.removeProduct(pro.id)} >
              Quitar
            </button>
          </td>
        </tr>
      );
    });
    return (
      <tbody>
        {productos}
      </tbody>
    );
  }

  renderFooter(){
    let total = 0;
    _.mapValues(this.props.carrito, (pro)=>{
      total += parseInt(pro.costo, 10);
    })
    return (
      <thead className="thead-light">
        <tr>
          <th scope="col" colSpan="2" >Total</th>
          <th scope="col" className="cost">{accounting.formatMoney(total, "Gs", 0, ".")}.-</th>
          <th></th>
        </tr>
      </thead>
    );
  }

  clearList(event){
    event.preventDefault();
    if (window.confirm('Está a punto de eliminar todos los productos del carrito'))
      this.props.limpiarCarrito();
  }

  removeProduct(idproduct){
    this.props.quitarCarrito(idproduct);
  }

  processPurchase(event){
    event.preventDefault();
    let total = 0;
    _.mapValues(this.props.carrito, (pro)=>{
      total += parseInt(pro.costo, 10);
    })

    if(this.props.usuario===null || this.props.usuario.session_token===null){
      NotificationManager.error("Inicie sesión para procesar su compra");
      return;
    }

    this.props.singleBuy(this.props.usuario, _.values(this.props.carrito), total);
  }



  render(){
    if(Object.keys(this.props.carrito).length<=0){
      NotificationManager.warning("Su carrito está vacío, será redirigido a la pantalla de inicio", "Carrito Vacío", 5000);
      return <Redirect push to="/cursos/1" />;
    }

    return (
      <div id="carrito">
        <div className="container" >
          <h1>Carrito de Compras</h1>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">COD</th>
                <th scope="col">Descripción</th>
                <th scope="col" className="cost">Costo</th>
                <th></th>
              </tr>
            </thead>
            {this.renderLista()}
            {this.renderFooter()}
          </table>
          <form onSubmit={this.processPurchase}>
            <div className="btn-group  float-right" role="group" aria-label="Basic example">
              <Link
                to="/"
                className="btn btn-secondary" >
                  Seguir Eligiendo
              </Link>
              <button
                className="btn btn-secondary"
                onClick={this.clearList} >
                  Limpiar Lista
              </button>
              <button
                type="submit"
                className="btn btn-primary" >
                  Procesar Compra
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ carrito, usuario }) {
  return { carrito, usuario };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    quitarCarrito,
    limpiarCarrito,
    singleBuy,
    getTransactionDetails
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Carrito);



// WEBPACK FOOTER //
// ./src/containers/carrito.js